<template>
  <modal
    title="Public Fleet"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="">
      <span class="py-2 block my-1 opacity-50">Fleet Revenue Share </span>
    </div>
    <p class="text-sm my-2">
      How do you prefer to split revenue when third-party carrier leases your
      fleet?
    </p>

    <div class="flex items-center mb-5 mt-5">
      <div class="w-6/12">My Company</div>
      <div class="flex items-center w-6/12 py-2 px-2 border-2 border-gray-200">
        <span class="inline-block input-field "
          ><abbr class="w-10 outline-none">{{ companyRatio }}%</abbr></span
        >
        <span>
          <img
            src="@/assets/images/icons/input_arrow.svg"
            alt="information icon"
            @click="revenueSplit('company', 'inc')"
          />
          <img
            src="@/assets/images/icons/input_arrow.svg"
            class="transform rotate-180 mt-2"
            alt="information icon"
            @click="revenueSplit('company', 'dec')"
          />
        </span>
      </div>
    </div>

    <div class="flex items-center mb-4">
      <div class="w-6/12">Third-party Carrier</div>
      <div class="flex items-center w-6/12 py-2 px-2 border-2 border-gray-200">
        <span class="inline-block input-field "
          ><abbr class="w-10 outline-none"
            >{{ 100 - companyRatio }}%</abbr
          ></span
        >
        <span>
          <img
            @click="revenueSplit('carrier', 'dec')"
            src="@/assets/images/icons/input_arrow.svg"
            alt="information icon"
          />
          <img
            src="@/assets/images/icons/input_arrow.svg"
            class="transform rotate-180 mt-2"
            alt="information icon"
            @click="revenueSplit('carrier', 'inc')"
          />
        </span>
      </div>
    </div>

    <div class="single-option mt-6">
      <label class="w-full flex items-center justify-between">
        <span>Preferred Routes</span>
        <span class="flex items-center justify-end">
          <label for="anyRoute" class="radio-label label -mt-3">
            <input
              type="radio"
              id="anyRoute"
              value="anyRoute"
              v-model="route"
            />
            <span></span> </label
          ><abbr class="ml-1">Any Route</abbr></span
        >
      </label>

      <el-select filterable v-model="selectedRoute" placeholder="All">
        <el-option
          v-for="state in routes"
          :key="state.id"
          :label="state.locationName"
          :value="state.id"
        >
        </el-option>
      </el-select>
    </div>

    <div class="flex items-center mt-4">
      <span class="w-full mr-3">
        Approve fleet lease when a third-party adds this fleet.
      </span>
      <el-switch v-model="approveFleet" />
    </div>

    <div class="actions flex items-center justify-between cursor-pointer mt-5">
      <div>
        <p class="pl-3" @click="closeModal">Cancel</p>
      </div>
      <div>
        <primary-button @click="submit" buttonText="Save" :loading="loading" />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    
  },

  data() {
    return {
      loading: false,
      fleets: [],
      route: "anyRoute",
      selectedRoute: "",
      approveFleet: true,
      companyRatio: 70,
      routes: [],
      filter: {
        route: "",
        fleet: "",
        terminal: "",
        country: "",
      },
    };
  },
  mounted() {
    this.getFleets();
    this.getAllRoutes();
  },
  computed: {
    revenuePayload(){
      return {
        myCompanyPacentage: this.companyRatio,
        thirdPartyPacentage: (100 - this.companyRatio),
        preferedRouteId: this.selectedRoute,
        anyPreferedRoute: true,
        approveForPublicUse: this.approveFleet,
      }
    }
  },
  methods: {
    submit(){
     this.$emit('updatePublicFleet', this.revenuePayload);
     this.closeModal()
    },
    revenueSplit(type, action) {
      switch (type) {
        case "company":
          action == "inc" ? this.increaseratio() : this.decreaseratio();
          break;

        case "carrier":
          action == "inc" ? this.increaseratio() : this.decreaseratio();
          break;
      }
    },
    increaseratio() {
      if (this.companyRatio == 100) return;
      this.companyRatio = this.companyRatio + 10;
    },
    decreaseratio() {
      if (this.companyRatio == 0) return;
      this.companyRatio = this.companyRatio - 10;
    },
    closeModal() {
      this.$emit("close-modal");
    },
    async getFleets() {
      try {
        let response = await this.$_getAllFleets();
        this.fleets = response.data.data.fleet;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getAllRoutes() {
      try {
        let response = await this.$_getAll3plLocations();

        this.routes = response.data.data.locations;
        console.log(  this.routes)
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.input-field {
  width: 90%;
}

.individual-contaoner {
  @apply w-full border-2 border-gray-300 border-dashed p-2 my-3;
}
.filter-search {
  border-radius: 4px;
  @apply py-2;
}
</style>
